import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-calculation',
  templateUrl: './delete-calculation.component.html',
  styleUrls: ['./delete-calculation.component.scss'],
  standalone: false,
})
export class DeleteCalculationComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
